<template>
  <div class="app">
    <!-- <img v-if="sUrl" :src="sUrl" class="preview-img" /> -->
    <div class="share-wrap" ref="canvas">
      <h3 class="tt">A.O.史密斯<br />用户安装实例</h3>
      <div class="user-infos">
        <div class="headimg">
          <img
            src="https://pro-core.babycdn.com/2020/08aosmith/images2020/release_case/headimg.jpg"
          />
        </div>
        <div class="info">
          <h5>案例信息</h5>
          <div class="txt"><span>城市：{{oDetails.city_name}}</span><span>小区：{{oDetails.address}}</span></div>
          <div class="txt" v-if="oDetails.house_area">面积：{{ oDetails.house_area }}m²</div>
        </div>
      </div>
      <!-- 限时福利 -->
      <div class="coupon-section-wrap long" v-if="arrActivityList.length">
        <h3>限时福利</h3>
        <ul>
          <li v-for="item in arrActivityList" :key="item.activityId">
            <div class="img-box">
              <img v-lazy="item.data.bannerUrl" :key="item.data.bannerUrl" />
            </div>
            <div class="detile-box">
              <h4>{{ item.data.activityName }}</h4>
              <h5>
                {{ item.data.startTime.substr(0, 10) }} 至
                {{ item.data.endTime.substr(0, 10) }}
              </h5>
              <div class="tips-box">
                <p class="pren">已有{{ item.data.enter }}人报名参加</p>
                <div class="sign-btn" @click="sginActivtiy(item.activityId)">
                  立即报名
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 安装案例 -->
      <div class="case-list">
        <!-- <h3>安装案例</h3> -->
        <div class="case-item" v-if="oDetails.genre_img">
          <h5>口碑晒单</h5>
          <div class="image-wrap">
            <img
              v-lazy="oDetails.genre_image[0].img_url"
              alt="图片"/>
          </div>
        </div>

        <div
          class="case-item"
          v-for="item in oDetails.new_scenes"
          :key="item.id"
        >
          <h5>{{ item.scenes_name ? item.scenes_name + "场景" : "" }}</h5>
          <!-- <div class="xian"></div> -->
          <!-- <div class="kitchen">
            <div class="chenleft">
              <p>{{item.scenes_name}}</p>
            </div>
            <div class="chenright">
              <div v-for="(it,itindex) in item.icon " :key="itindex">
                <img :src="it.src" alt />
                <span>{{it.name}}</span>
              </div>
            </div>
          </div> -->
          <!-- <div class="orcss">
            <div class="list" v-for="(shopitem,shopindex) in item.goods_info" :key="shopindex">
              <div class="chenimg">
                <img :src="shopitem.mobile_thumb" v-if="shopitem.mobile_thumb" alt />
                <img :src="shopitem.pc_img" v-else alt />
              </div>
              <div class="chentext">
                <div>
                  <div class="nameitem">{{shopitem.goods_type_name}}</div>
                  <div class="nameitem">{{shopitem.goods_name}}</div>
                </div>
                <div class="del" @click="godetails(shopitem.id)">点击查看</div>
              </div>
            </div>
          </div> -->
          <div
            class="image-wrap"
            v-for="(imgitem, imgindex) in item.house_img"
            :key="imgindex"
          >
            <img v-lazy="imgitem.img_url" alt="图片" @click="swiperChange(item.arrImg,imgindex)"/>
          </div>
          <div class="viebeo" v-if="item.mp4">
            <video
              :src="item.mp4 ? item.mp4 : ''"
              controls
            ></video>
          </div>
          <div class="goods-wrap" v-if="item.goods_info.length">
            <div class="titel">
              <span class="left"></span>
              案例中的商品
              <span class="right"></span>
            </div>
            <ul class="goods-list">
              <li
                v-for="git in item.goods_info"
                :key="git.id"
                v-if="git.id"
                @click="godetails(git.id)"
              >
                <div class="img-box">
                  <img :src="git.mobile_thumb" />
                </div>
                <div class="title">
                  <div>{{ git.goods_type_name }}</div>
                  <div>{{ git.goods_name }}</div>
                  <div
                    class="selling"
                    v-for="(gitem, gindex) in git.attr"
                    :key="gindex"
                    v-if="gitem.attr_mean < 4 && gindex < 3"
                  >
                    <span>·</span>{{ gitem.attr_value }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="nearby" @click="gonearby">查看更多身边案例</div>
        <!-- <div>{{userId}}</div> -->
      </div>
      <!-- 底部 -->
      <div class="seller-box">
        <div
          class="info"
          v-if="arrCards.name || arrCards.mobile || arrCards.qrCode"
        >
          <div class="user-info">
            <div class="avatar">
              <img v-lazy="arrCards.avatar" alt />
            </div>
            <div class="genduo_img"></div>
          </div>
          <div class="wrap-info">
            <div class="ercode-box">
              <div class="ercode">
                <img v-lazy="arrCards.qrCode" />
              </div>
              <div class="content">
                <ul>
                  <li>
                    <div class="lable">微信昵称</div>
                    <div id="nickname">{{ arrCards.name }}</div>
                  </li>
                  <li class="phone">
                    <div class="lable">电话</div>
                    <div id="phone">{{ arrCards.mobile }}</div>
                  </li>
                </ul>
                <p>一键保存名片/添加好友</p>
              </div>
            </div>
          </div>
        </div>
        <div class="logo">
          <img src="@/assets/images/system/logo2.png" />
        </div>
        <!-- 预览图片 -->
          <div class="preview-img" v-show="showSwiper">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="item in arrSwiperImg" :key="item.id">
                <div class="swiper-zoom-container">
                  <img :src="item" alt />
                </div>
              </swiper-slide>
              <!--<div class="swiper-pagination "  slot="pagination"></div>-->
            </swiper>
          </div>
          <div v-show="showSwiper" class="close-preview" @click="closeSwiper">
            关闭预览
          </div>
          <!-- 预览头图 -->
          <div class="preview-img" v-show="headerSwiper">
            <swiper :options="swiperOptiontwo" ref="mySwipertwo">
              <swiper-slide v-for="item in arrHeaderImg" :key="item.id">
                <div class="swiper-zoom-container">
                  <img :src="item" alt />
                </div>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
          <div
            v-show="headerSwiper"
            class="close-preview"
            @click="getheaderSwiper"
          >
            关闭预览
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import path from "@/path.js";
import html2canvas from "html2canvas";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      oDetails: {
        card: {},
      }, //案例详情
      arrActivityList: [], //优惠券
      sUrl: "",
      userId:this.$route.query.userid,
      arrCards: [], //企业微信名片
      showSwiper: false, //预览图片
      headerSwiper: false, //预览头图
      arrHeaderImg: [], //头图
      arrSwiperImg: [], //需要预览的图片
      swiperIndex: 2,
      swiperIndextwo: 0,
      swiperOption: {
        clickable: true,
        noSwiping: true,
        zoom: true,
        on: {
          slideChangeTransitionStart: function (swiper) {
            this.swiperIndex = this.swiper.activeIndex;
          }.bind(this),
        },
      },
      swiperOptiontwo: {
        clickable: true,
        noSwiping: true,
        zoom: true,
        on: {
          slideChangeTransitionStart: function (swipertwo) {
            this.swiperIndextwo = this.swipertwo.activeIndex;
          }.bind(this),
        },
      },
    };
  },
  created() {
    // alert(this.$route.query.sShareIds)
  },
  mounted() {
    this.getDetails();
    this.getCards();
  },
  computed: {
    swiper() {
      this.swiperIndex = this.$refs.mySwiper.swiper.activeIndex;
      return this.$refs.mySwiper.swiper;
    },
    swipertwo() {
      this.swiperIndextwo = this.$refs.mySwipertwo.swiperIndextwo.activeIndex;
      return this.$refs.mySwipertwo.swiperIndextwo;
    },
  },
  methods: {
    //点击打开预览
    swiperChange(arr,index) {
      var that = this;
      //  console.log(index);
      if (index >= 0) {
        that.showSwiper = true;
        this.arrSwiperImg=[];
        this.arrSwiperImg=arr;
        that.swiper.slideTo(index, 1000, true);
      }
    },
    //点击关闭预览
    closeSwiper() {
      var that = this;
      that.showSwiper = false;
    },
    //点击打开预览头图
    headerChange(index) {
      var that = this;
      //  console.log(index);
      if (index >= 0) {
        that.headerSwiper = true;
        that.swiper.slideTo(index, 1000, true);
      }
    },
    //点击关闭预览头图
    getheaderSwiper() {
      var that = this;
      that.headerSwiper = false;
    },
    //点击跳转附近案例
    gonearby() {
      wx.miniProgram.reLaunch({ url: "/pages/case/case_map_vue/index" });
    },
    //点击跳转详情页
    godetails(id) {
      //  console.log("商品id", id);
      wx.miniProgram.navigateTo({ url: `/pages/pro_type_v2/index?id=${id}` });
    },
    async getDetails() {
      // this.$store.commit("loadBgSwitch",true);
      this.$store.commit("loadSwitch", true);
      //  console.log("userid", this.$route.query.userid);
      let data = {
        topic_id: this.$route.query.topicid,
        user_id: this.$route.query.userid,
        source: "xcx",
        activity_id: this.$route.query.sShareIds || "",
      };
      // alert(this.$route.query.sShareIds)
      let oDetails = await path.post5(path.gettopic, data);
      this.$store.commit("loadSwitch", false);
      if (!oDetails.data.data.result.card) {
        oDetails.data.data.result.card = {};
      }
      let arrNewscenes = oDetails.data.data.result.new_scenes;
      let arrSwiperImg = [];
      let arrHeaderImg = [];
      arrHeaderImg.push(oDetails.data.data.result.cover);
      this.arrHeaderImg = arrHeaderImg;
      arrNewscenes.forEach((it) => {
        it.arrImg = [];
        it.house_img.forEach((img) => {
          it.arrImg.push(img.img_url);
        });
      });
      this.oDetails = oDetails.data.data.result;
      this.arrActivityList = oDetails.data.data.result.activity;
      //  console.log(this.arrActivityList);
      //  console.log(this.oDetails);
    },
    getCards() {
      let data = {
        source: "xcx",
        user_id: this.$route.query.tp5Userid,
      };
      path.post5(path.getCards, data).then((res) => {
        let arrCards = res.data.data.result;
        this.arrCards = arrCards;
      });
    },
    // 报名活动
    sginActivtiy(id) {
      wx.miniProgram.navigateTo({
        url: `/pages/watersystem/miniprogram/index?sAppId=${path.APPID}&sEnvVersion=${path.envVersion}&sId=${id}&topicid=${this.$route.query.topicid}`,
      });
    },
    htmlToImage() {
      let sHeight = document.querySelector(".share-wrap").offsetHeight;
      let sWidth = document.querySelector(".share-wrap").offsetWidth;
      var scale = 2;
      html2canvas(this.$refs.canvas, {
        useCORS: true,
        logging: false,
        height: sHeight,
        width: sWidth,
        dpi: window.devicePixelRatio,
        scale: scale,
      })
        .then((canvas) => {
          let sUrl = canvas.toDataURL("image/png");
          // this.sUrl = sUrl;
          // console.log(sUrl)
        })
        .catch((fail) => {
          //  console.log(fail);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "sharelink.scss";
</style>
